/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React, { useState } from "react"
import { H2, Text, Button, FlexContainer, Modal, TextLink, Body } from "@carrotfertility/carotene"
import { IlloEnvelopeCheck } from "../views/atoms/Illustrations"
import { useHistory } from "react-router"
import { useCurrentUser } from "../context/user/UserContext"
import { FormattedMessage } from "react-intl"
import { Typography } from "@carrotfertility/carotene-core"
import EmployeeOnlyModalContainer from "../employee-only-containers/EmployeeOnlyModalContainer"
import { PiiText } from "services/tracking"

export default function EmailVerifiedModal(): JSX.Element {
  const [open, setOpen] = useState(true)
  const { personalEmail } = useCurrentUser()
  const history = useHistory()

  function closeModal() {
    history.push({
      pathname: "/",
      state: { showPersonalEmailVerifiedModal: false, showVerifyEmailModal: false }
    })
    setOpen(false)
  }

  return (
    <EmployeeOnlyModalContainer onClose={closeModal} open={open}>
      <Modal open={open} onClose={closeModal} showClose={false}>
        <FlexContainer paddingTopBottom={"32px"} alignItems={"center"} direction={"column"}>
          <IlloEnvelopeCheck />
        </FlexContainer>

        <FlexContainer stack={"large"} paddingLeftRight={"48px"} alignItems={"center"} direction={"column"}>
          <Text align={"center"}>
            <H2 stack={"tiny"}>
              <FormattedMessage defaultMessage="Your email address has been verified" />
            </H2>
            <Body>
              <FormattedMessage
                defaultMessage="We'll communicate with you at <bold>{personalEmail}.</bold>"
                values={{
                  personalEmail: personalEmail,
                  bold: (boldContent) => (
                    <Typography component={PiiText} fontWeight="bold" style={{ display: "block" }}>
                      {boldContent}
                    </Typography>
                  )
                }}
              />
            </Body>
            <Body>
              <FormattedMessage
                defaultMessage="To change this, go to <TextLink>Account settings</TextLink>."
                values={{
                  TextLink: (textLinkContent) => (
                    <TextLink color={"black"} size={"medium"} to={"/account#email-addresses"}>
                      {textLinkContent}
                    </TextLink>
                  )
                }}
              />
            </Body>
          </Text>
        </FlexContainer>

        <FlexContainer stack={"medium"} alignItems={"center"} direction={"column"}>
          <Button onClick={closeModal}>
            <FormattedMessage defaultMessage="Close" />
          </Button>
        </FlexContainer>
      </Modal>
    </EmployeeOnlyModalContainer>
  )
}
